<svg *ngIf="selected" [climbIcon]="icons.caretRightFilled"></svg>
<ng-content></ng-content>
